











































































import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { range, constrain } from '../../../shared/helper-functions';

@Component({})
export default class Paginate extends Vue {
  @Prop({ default: 1 })
  public totalNrOfPages!: number;

  @Prop({ default: 5 })
  public maxNrOfPageNumbers!: number;

  @Model('page-changed', { type: Number, default: 1 })
  public readonly activePage!: number;

  public get previousIsDisabled() {
    return this.activePage === 1;
  }

  public get nextIsDisabled() {
    return this.activePage === this.totalNrOfPages;
  }

  public get maxPagesExceeded(): boolean {
    return this.totalNrOfPages > this.maxNrOfPageNumbers;
  }

  public get showEndPageEllipsis() {
    return (
      this.activePage < this.totalNrOfPages - 2 &&
      Math.abs((this.visiblePageNumbersRange[this.visiblePageNumbersRange.length - 1] || 0) - this.totalNrOfPages) > 1
    );
  }

  public get showStartPageEllipsis() {
    return this.activePage > 3 && this.visiblePageNumbersRange[0] > 2;
  }

  public get visiblePageNumbersRange(): number[] {
    if (!this.maxPagesExceeded) {
      return range(2, this.totalNrOfPages - 1);
    }
    const nrOfPagesInTheMiddle = this.maxNrOfPageNumbers - 2;
    if (this.activePage - nrOfPagesInTheMiddle < 0) {
      return range(2, nrOfPagesInTheMiddle + 1);
    }
    if (this.activePage + nrOfPagesInTheMiddle > this.totalNrOfPages) {
      return range(this.totalNrOfPages - nrOfPagesInTheMiddle, this.totalNrOfPages - 1);
    }
    const halfRoundedDown = Math.floor(nrOfPagesInTheMiddle / 2);
    const start = this.activePage - halfRoundedDown;

    let end;
    end = this.activePage + halfRoundedDown;
    if (nrOfPagesInTheMiddle % 2 === 0) {
      // if nrOfPages in the middle is even: always put the active number in the place to the right of the middle;
      end = end - 1;
    }
    return range(constrain(start, 2, this.totalNrOfPages), constrain(end, 2, this.totalNrOfPages - 1));
  }

  public onPrevious() {
    this.onPageChange(Math.max(1, this.activePage - 1));
  }

  public onNext() {
    this.onPageChange(Math.min(this.totalNrOfPages, this.activePage + 1));
  }

  public onPageChange(newPage: number) {
    this.$emit('page-changed', newPage);
  }

  public pageIsActive(page: number): boolean {
    return this.activePage === page;
  }
}
